import React from 'react';
import { func } from 'prop-types';
import { intlShape, FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';

import config from '../../../../config';
import { withViewport } from '../../../../util/contextHelpers';
import { propTypes } from '../../../../util/types';
import { PrimaryButton, IconCheckCross } from '../../../../components';

import css from './Refusal.module.css';
import { TRANSITION_COUNTER_PROPOSAL_DECLINE } from '../../../../util/transactions';
import { ensureTransaction } from '../../../../util/data';
import { getUserDisplayNameAsString } from '../../../UserDisplayName/UserDisplayName';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import { useHistory } from 'react-router-dom';

const Refusal = (props) => {
  const { intl, transition, transaction } = props;

  const history = useHistory();

  const currentTransaction = ensureTransaction(transaction);

  const displayName = getUserDisplayNameAsString({
    user: currentTransaction.provider,
    intl,
  });

  const findOtherPoolMessage = intl.formatMessage({ id: 'ActivityFeed.findOtherPool' });
  const contactSwimmyMessage = intl.formatMessage({ id: 'ActivityFeed.contactSwimmy' });
  const otherConfirmMessage = intl.formatMessage(
    {
      id: `ActivityFeed.${
        transition.transition === TRANSITION_COUNTER_PROPOSAL_DECLINE
          ? 'ownTransitionCounterProposalDecline'
          : 'transitionProposalDecline'
      }`,
    },
    {
      displayName,
    }
  );

  return (
    <div className={css.refusal}>
      <IconCheckCross className={css.refusalImg} />
      <p className={css.refusalContent}>{otherConfirmMessage}</p>
      <div className={css.refusalButtons}>
        <PrimaryButton
          className={css.refusalDetailsButton}
          onClick={() =>
            history.push(createResourceLocatorString('SearchPage', routeConfiguration(), {}, {}))
          }
        >
          {findOtherPoolMessage}
        </PrimaryButton>

        <PrimaryButton className={css.refusalDetailsButton}>
          <FormattedMessage
            id="ActivityFeed.contactSwimmy"
            values={{
              link: chunks => (
                <a
                  href={config.custom.openTicketLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontWeight: 600, color: "#0094EC" }}
                >
                  {chunks}
                </a>
              ),
            }}
          />
        </PrimaryButton>
      </div>
    </div>
  );
};

Refusal.defaultProps = {
  transition: null,
  transaction: null,
  currentUser: null,
  intl: null,
};

Refusal.propTypes = {
  transition: propTypes.transition.isRequired,
  transaction: propTypes.transaction.isRequired,
  currentUser: propTypes.currentUser.isRequired,
  intl: intlShape.isRequired,
  onManageDisableScrolling: func.isRequired,
  callSetInitialValues: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = (state) => {
  const { id } = state.listing;
  const { currentUser } = state.user;

  return {
    currentUser,
    listingId: id,
  };
};

export default compose(withViewport, connect(mapStateToProps, mapDispatchToProps))(Refusal);
